<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100%;
    }
    
    a {
        text-decoration: none;
    }
    
    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
    
    li {
        box-sizing: border-box;
    }
    
    div {
        box-sizing: border-box;
    }
    
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
       height: 100%;
        background: #eef0f5;
    }
    /* 富文本的样式默认修改  v-html */
.vHtmlMess {
    white-space: pre-wrap;
    font-size: 13px;
     img,video {
        max-width: 100% !important;
        height: auto;
    }

    table {
        border: none;
        border-collapse: collapse;
        max-width: 100% !important;
    }

    table td,
    table th {
        border: 1px solid #ccc;
        padding: 3px 5px;
        min-width: 50px;
        height: 20px;
    }

    table th {
        border-right: 1px solid #ccc;
        border-bottom: 2px solid #ccc;
        text-align: center;
        background-color: #f1f1f1;
    }
}
    .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue